"use client";

import type { LucideIcon } from "lucide-react";
import { Flame, LayoutGrid, PersonStanding, Spade, ToyBrick, Watch } from "lucide-react";
import { cn } from "@/lib/utils";

const BY_SLUG: Record<string, LucideIcon> = {
  lego: ToyBrick,
  other: LayoutGrid,
  sneakers: Flame,
  "trading-cards": Spade,
  figures: PersonStanding,
  vintage: Watch,
};

export function DiscoverCategoryIcon({
  slug,
  className,
  "aria-hidden": ariaHidden = true,
}: {
  slug: string;
  className?: string;
  "aria-hidden"?: boolean;
}) {
  const Icon = BY_SLUG[slug] ?? LayoutGrid;
  return (
    <Icon
      className={cn("shrink-0 text-muted-foreground", className)}
      strokeWidth={2}
      aria-hidden={ariaHidden}
    />
  );
}
